(() => {
  if (window.ggProductDocumentationReady) return;
  window.ggProductDocumentationReady = true;
  const clean = value => value.replace(/\s+/g, ' ').trim();
  const initialize = panel => {
    if (panel.dataset.ready) return;
    panel.dataset.ready = 'true';
    const source = panel.querySelector('[data-gg-documentation-source]');
    const facts = panel.querySelector('[data-gg-documentation-facts]');
    if (!source || !facts) return;
    try {
      const html = JSON.parse(source.textContent);
      const doc = new DOMParser().parseFromString(html || '', 'text/html');
      doc.querySelectorAll('script,style,noscript,template').forEach(node => node.remove());
      const rows = { authentication: [], included: [], edition: [], condition: [] };
      const record = (label, value) => {
        label = clean(label).replace(/[:：]$/, '').toLowerCase();
        value = clean(value);
        if (!value || value.length > 1600 || /OneCOA|Verisart/i.test(value)) return;
        let key;
        if (/^(authentication|authenticator|documentation|certificate|certificate number|certificate no\.?|coa|loa|coa number|loa number|certification|letter of authenticity)$/.test(label)) key = 'authentication';
        else if (/^(edition|edition size|edition number|numbering|numbered)$/.test(label)) key = 'edition';
        else if (/^(condition|overall condition|condition notes)$/.test(label)) key = 'condition';
        else if (/^(included|what is included|what’s included|what's included|what you receive|in the box)$/.test(label)) key = 'included';
        if (key && !rows[key].includes(value)) rows[key].push(value);
      };
      doc.querySelectorAll('tr').forEach(row => {
        const cells = Array.from(row.children).filter(cell => /^(TH|TD)$/.test(cell.tagName));
        if (cells.length === 2) record(cells[0].textContent, cells[1].textContent);
      });
      doc.querySelectorAll('p,li').forEach(node => {
        const text = clean(node.textContent);
        const match = text.match(/^([^:：]{2,28})[:：]\s*(.+)$/);
        if (match) record(match[1], match[2]);
      });
      doc.querySelectorAll('h2,h3,h4').forEach(heading => {
        const label = clean(heading.textContent);
        const conditionHeading = /^condition(?: notes)?(?:\s*[:：—–-].*)?$/i.test(label);
        if (!conditionHeading && !/^(what(?: is|'s|’s) included|included|what you receive|in the box)[:：]?$/i.test(label)) return;
        const parts = [];
        for (let next = heading.nextElementSibling; next && !/^H[1-6]$/.test(next.tagName); next = next.nextElementSibling) {
          if (/^(UL|OL)$/.test(next.tagName)) Array.from(next.children).forEach(li => parts.push(clean(li.textContent)));
          else if (next.tagName === 'P') parts.push(clean(next.textContent));
          if (parts.length >= 8) break;
        }
        record(conditionHeading ? 'condition' : label, parts.join(' • '));
      });
      ['authentication', 'included', 'edition', 'condition'].forEach(key => {
        if (!rows[key].length) return;
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = panel.dataset[`${key === 'authentication' ? 'auth' : key}Label`];
        const value = rows[key].join('\n');
        if (value.length > 240) {
          const details = document.createElement('details');
          const summary = document.createElement('summary');
          const fullText = document.createElement('p');
          summary.textContent = panel.dataset.expandLabel;
          fullText.textContent = value;
          details.append(summary, fullText);
          description.append(details);
        } else description.textContent = value;
        row.append(term, description);
        facts.append(row);
      });
      const hasDocuments = rows.authentication.length || rows.included.some(value => /\b(COA|LOA|certificate|paperwork|documentation)\b/i.test(value));
      panel.querySelector('[data-gg-documentation-unspecified]').hidden = Boolean(hasDocuments);
    } catch {}
    const photos = panel.querySelector('[data-gg-documentation-photos]');
    photos?.addEventListener('click', event => {
      const scope = panel.closest('[data-product-section],.ggp');
      const gallery = scope?.querySelector('.product-media,.ggp__gallery');
      if (!gallery) return;
      event.preventDefault();
      gallery.scrollIntoView({ block: 'center', behavior: 'instant' });
      gallery.tabIndex = -1;
      gallery.focus({ preventScroll: true });
    });
  };
  const scan = root => {
    if (root.matches?.('[data-gg-documentation]')) initialize(root);
    root.querySelectorAll?.('[data-gg-documentation]').forEach(initialize);
  };
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => {
    if (node.nodeType === 1) scan(node);
  }))).observe(document.body, { childList: true, subtree: true });
})();
